import { useState } from 'react';
import myLogo from '../assets/myName.png';

export default function Navbar() {
  const navbarStyle = 'block text-gray-700 rounded p-0 font-subHeaders';
  const [isMenuHidden, setIsMenuHidden] = useState(true);

  function handleToggle() {
    setIsMenuHidden(!isMenuHidden);
    console.log("Helllo")
  }

  return (
    <nav className={`bg-brown backdrop-blur-lg bg-opacity-70 z-50 fixed shadow-x px-2 sm:px-4 py-2.5 top-0 left-0 flex flex-wrap
    justify-between
    w-full `}>
      <div >
        <a href="#Home" className="flex items-center">
          <img
            src={myLogo}
            className="h-8 mr-3 sm:h-14 rounded-lg l"
            alt="Hayat Salawdeh"
          />
        </a>
        </div>
     
          
          <svg
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            id="menu-button"
            className="h-6 w-6 cursor-pointer md:hidden block"
            onClick={()=>handleToggle()}
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            ></path>
          </svg>
        

        <div
          className={`${isMenuHidden ? 'hidden' : ''} w-full md:flex md:items-center md:w-auto`} id="menu"
        >
          <ul className="flex p-4 mt-4 rounded-lg flex-row  space-x-8 mt-0 text-sm font-medium border-0 text-darkBrown md:flex
              md:justify-between 
              md:pt-0">
            <li>
              <a
                href="#Home"
                className="block text-gray-700 rounded p-0 font-subHeaders"
                aria-current="page"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#About"
                className="block text-gray-700 rounded p-0 font-subHeaders"
              >
                About
              </a>
            </li>

            <li>
              <a
                href="#Projects"
                className="block text-gray-700 rounded p-0 font-subHeaders"
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="#Contact"
                className="block text-gray-700 rounded p-0 font-subHeaders"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
    </nav>
  );
}
